exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.md-card[data-v-975f3e00] {\n  background: unset !important;\n  box-shadow: unset !important;\n  margin: 4px;\n  display: inline-block;\n  vertical-align: top;\n}\n.md-card span.logo[data-v-975f3e00] {\n    font-weight: bold;\n}\n", ""]);

// exports
